import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { SectionChips } from '../SectionChips';

export const Loading: React.FC = () => {
	return (
		<div
			className="rounded-2xl border-none bg-white p-6"
			id="social-media-content-container"
			data-qa="social-media-content-container"
			data-testid="social-media-content-loading-container"
		>
			<div className="mb-5 flex flex-col gap-3">
				<Text
					id="social-media-content-title"
					data-qa="social-media-content-title"
					variant="heading"
					as="h3"
					className="text-size-heading-xs text-typography-strong md:text-size-heading-small"
				>
					<Translate value="corgi.petition.starter_dashboard_v2.social_media_content.title" />
				</Text>
				<Text as="p">
					<Translate value="corgi.petition.starter_dashboard_v2.social_media_content.description" />
				</Text>
			</div>
			<div>
				<SectionChips section="" setSection={() => {}} showStories showPosts />
			</div>
			<div className="flex h-full flex-col">
				<div className="flex h-full snap-x flex-nowrap gap-4 overflow-x-scroll overflow-y-visible pb-0">
					<div className="h-96 w-52 shrink-0 rounded-lg bg-[#e1dde9] lg:w-auto lg:flex-1"></div>
					<div className="h-96 w-52 shrink-0 rounded-lg bg-[#e1dde9] lg:w-auto lg:flex-1"></div>
					<div className="h-96 w-52 shrink-0 rounded-lg bg-[#e1dde9] lg:w-auto lg:flex-1"></div>
					<div className="h-96 w-52 shrink-0 rounded-lg bg-[#e1dde9] lg:w-auto lg:flex-1"></div>
				</div>
			</div>
		</div>
	);
};
